<mf-grid
  #grid
  actionButtonText="{{ showCreateButton ? 'Nueva orden de pago' : '' }}"
  [apiEndpoint]="apiEndpoint"
  [disableActionButton]="disableCreateButton"
  [actionButtonAsSecondary]="actionButtonAsSecondary"
  [columns]="columns"
  [hideFilters]="hideFilters"
  [initialFilters]="filters"
  [mustIncludeFields]="mustIncludeFields"
  [menuItems]="menuItems"
  [preventHeightResize]="true"
  (actionButtonClick)="openNewPaymentOrderPopup()" />
